import { AxiosRequestConfig, AxiosResponse } from "axios";
import { API_PATH } from "../server-data";
import { axiosAuth } from "./interceptor";
import { bulkUploadErrors } from "../constants/bulkUploadErrors";

export const getEmissionCurrencyService = (
  EmissionRequestObject?: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: { type: "Currency" },
  };
  return axiosAuth.get(API_PATH().apis.currencies, config);
};
export const getAllUomsService = (): Promise<AxiosResponse> => {
  return axiosAuth.get(API_PATH().apis.currencies);
};
export const updateEmissionStatus = (
  EmissionStatusObject: any
): Promise<AxiosResponse> => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  return axiosAuth.put(API_PATH().apis.emissionstatus, {
    ...EmissionStatusObject,
    owner: user.owner,
    lastUpdatedBy: user.owner,
    lastUpdatedByName: user.displayName || user.email,
  });
};
export const getCurrencyUomService = (
  EmissionRequestObject?: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: EmissionRequestObject,
  };
  return axiosAuth.get(API_PATH().apis.uom, config);
};
export const emissionScopeService = (EmissionObject?: {
  // type:number,
  // subtype:number,
  // method:number,
  categories: string;
}): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      ...EmissionObject,
    },
  };
  return axiosAuth.get(API_PATH().apis.scopecategories, config);
};
export const getEmissionFactorsHierarchy = (
  EmissionRequestObject?: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: EmissionRequestObject,
  };
  return axiosAuth.get(API_PATH().apis.emissionfactorshierarchy, config);
};

export const getEmissionListSummaryService = (EmissionObject: {
  id: string;
}): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: EmissionObject,
  };
  const from_date =
    localStorage.getItem("from_date") && localStorage.getItem("from_date");
  const to_date =
    localStorage.getItem("to_date") && localStorage.getItem("to_date");
  if (from_date && to_date) {
    config.params.from_date = from_date;
    config.params.to_date = to_date;
    let user = JSON.parse(localStorage.getItem("user") || "{}");
    config.params.auditor = user.id;
  }
  return axiosAuth.get(API_PATH().apis.emission, config);
};
export const createEmissionService = (
  EmissionObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.emission, EmissionObject);
};
export const UpdateCustomEmissionService = (
  EmissionObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.put(API_PATH().apis.customemissionfactor, EmissionObject);
};

export const updateEmissionLogService = (
  EmissionObject: any
): Promise<AxiosResponse> => {
  // {
  //   emissionLogId: string;
  //   emissionId: string;
  //   Value: string;
  //   uom: string;
  //   uomName: string;
  // }
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const displayName = user.displayName
    ? user.displayName
    : user.email.split("@")[0];
  return axiosAuth.put(API_PATH().apis.emissionlog, {
    ...EmissionObject,
    displayName: displayName,
    userId: user.owner,
  });
};
export const updateEmissionAttachmentService = (
  EmissionObject: any
): Promise<AxiosResponse> => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const displayName = user.displayName
    ? user.displayName
    : user.email.split("@")[0];
  return axiosAuth.put(API_PATH().apis.attachments, {
    ...EmissionObject,
    displayName,
  });
};
export const getEmissionListService = (
  EmissionObject: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      businessUnit:
        localStorage.getItem("currentBusinessUnit") &&
        JSON.parse(localStorage.getItem("currentBusinessUnit") || "").id,
    },
  };
  config.params.page = (EmissionObject.controller.page || 0) + 1;
  config.params.limit = EmissionObject.controller.limit;
  config.params.searchText = EmissionObject.searchText;
  config.params.statusFilter = EmissionObject.statusFilter;
  config.params.type = EmissionObject.type;
  if (EmissionObject.asset) {
    config.params.asset = EmissionObject.asset;
  }
  if (
    EmissionObject?.controller?.sortBy &&
    EmissionObject?.controller?.sortOrder
  ) {
    config.params.sortBy = EmissionObject?.controller?.sortBy;
    config.params.sortOrder = EmissionObject?.controller?.sortOrder;
  }
  if (EmissionObject?.filter?.statusFilter) {
    config.params.statusFilter = EmissionObject?.filter?.statusFilter;
  }
  const from_date =
    localStorage.getItem("from_date") && localStorage.getItem("from_date");
  const to_date =
    localStorage.getItem("to_date") && localStorage.getItem("to_date");
  if (from_date && to_date) {
    config.params.from_date = from_date;
    config.params.to_date = to_date;
    let user = JSON.parse(localStorage.getItem("user") || "{}");
    config.params.auditor = user.id;
    config.params.statusFilter = "Approved";
  }
  return axiosAuth.get(API_PATH().apis.emissions, config);
};

export const getRecentEmissions = (): // EmissionObject: any
Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      businessUnit:
        localStorage.getItem("currentBusinessUnit") &&
        JSON.parse(localStorage.getItem("currentBusinessUnit") || "").id,
    },
  };
  return axiosAuth.get(API_PATH().apis.recentemissions, config);
};

export const getEmissionValueTotalService = (
  EmissionObject: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      ...EmissionObject,
    },
  };
  config.params.page = (EmissionObject.page || 0) + 1;
  config.params.limit = EmissionObject.limit;
  return axiosAuth.get(API_PATH().apis.totalemissions, config);
};
export const getEmissionByScopeAndMonthService = (
  EmissionObject: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      ...EmissionObject,
    },
  };
  config.params.page = (EmissionObject.page || 0) + 1;
  config.params.limit = EmissionObject.limit;
  return axiosAuth.get(API_PATH().apis.emissionsbyscopeandmonth, config);
};
export const getCarbonPriceService = (
  EmissionObject: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      ...EmissionObject,
    },
  };

  return axiosAuth.get(API_PATH().apis.carbonprice, config);
};
export const getEmissionsByScopeandCategoriesService = (
  EmissionObject: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      ...EmissionObject,
    },
  };
  config.params.page = (EmissionObject.page || 0) + 1;
  config.params.limit = EmissionObject.limit;
  return axiosAuth.get(API_PATH().apis.emissionsbyscopeandcategories, config);
};

export const getAllEmissionsService = (
  EmissionObject: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      ...EmissionObject,
    },
  };
  config.params.page = (EmissionObject.page || 0) + 1;
  config.params.limit = EmissionObject.limit;
  return axiosAuth.get(API_PATH().apis.allemissions, config);
};

export const countriesService = (): Promise<AxiosResponse> => {
  return axiosAuth.get(API_PATH().apis.countries);
};

export const getEmissionSourceData = (
  category: string
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      category: category,
    },
  };
  return axiosAuth.get(API_PATH().apis.emissionsource, config);
};
export const emissionAvailableCategoriesService = (
  company: number,
  fetchAllCategories: boolean
): Promise<AxiosResponse> => {
  const params: any = {
    protocol: "ISO",
    company: company,
  };
  fetchAllCategories && (params["fetchAllCategories"] = true);
  let config: AxiosRequestConfig = {
    params,
  };
  console.log("ccc", config);
  return axiosAuth.get(API_PATH().apis.availablecategories, config);
};
export const emissionCategoriesByProtocolService =
  (): Promise<AxiosResponse> => {
    let config: AxiosRequestConfig = {
      params: {
        protocol: "ISO",
        categoryLevel: "SubCategory1",
      },
    };
    return axiosAuth.get(API_PATH().apis.protocolcategories, config);
  };
export const getVehiclesService = (): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      protocol: "ISO",
      type: "vehicle",
      moduleGroup: 4,
      categoryLevel: "SubCategory1",
    },
  };
  return axiosAuth.get(API_PATH().apis.moduletypes, config);
};
export const getEmissionFactorsService = (EmissionRequestObject: {
  country: string;
  method: string;
  categoryId: string;
}): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: EmissionRequestObject,
  };
  return axiosAuth.get(API_PATH().apis.factors, config);
};
export const getUOMService = (EmissionRequestObject: {
  country?: string;
  method: string;
  type: string;
  sub_type?: string;
  emission_source?: string;
  categoryId: string;
}): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: EmissionRequestObject,
  };
  return axiosAuth.get(API_PATH().apis.uoms, config);
};
export const getEmissionTypesService = (
  EmissionRequestObject: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: EmissionRequestObject,
  };
  return axiosAuth.get(API_PATH().apis.emissiontypes, config);
};
export const getEmissionMethodService = (
  EmissionRequestObject: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: EmissionRequestObject,
  };
  return axiosAuth.get(API_PATH().apis.methodsbyfactors, config);
};

export const emissionsByMonthService = (EmissionObject: {
  businessUnitIds: string;
}): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: { ...EmissionObject },
  };
  return axiosAuth.get(API_PATH().apis.emissionsmonth, config);
};
export const emissionsByUnitService = (EmissionObject: {
  businessUnitIds: string;
}): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: { ...EmissionObject },
  };
  console.log("EmissionObject", EmissionObject);
  console.log("EmissionObject", config);
  return axiosAuth.get(API_PATH().apis.emissionsbyunit, config);
};

export const moduletypesbygroups = (EmissionRequestObject: {
  moduleGroup: string;
}): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: { ...EmissionRequestObject },
  };
  return axiosAuth.get(API_PATH().apis.moduletypesbygroups, config);
};
export const bulkUploadService = (
  requestObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.bulkupload, requestObject);
};
export const bulkUploadImportFileService = (
  EmissionRequestObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.importfile, EmissionRequestObject);
};
export const bulkUploadProcessFileService = (
  requestObject: any
): Promise<AxiosResponse> => {
  console.log("RequestObject", requestObject);
  if (requestObject.typeName == "Emission Activities") {
    return axiosAuth.post(API_PATH().apis.processfile, requestObject);
  } else {
    return axiosAuth.post(API_PATH().apis.supplierBulkUpload, requestObject);
  }
};

export const getSampleFileService = (EmissionRequestObject: {
  emissionType: number;
  emission_sub_type: number;
  emission_method: number;
  category: number;
  type_name: string;
}) => {
  let config: AxiosRequestConfig = {
    params: EmissionRequestObject,
  };
  return axiosAuth.get(API_PATH().apis.samplefile, config);
};

export const importFilesService = (EmissionObject: {
  controller: any;
  category?: number;
  type_name: string;
  isCompanyLevel?: boolean;
}): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      category: EmissionObject.category,
      type_name: EmissionObject.type_name,
    },
  };
  if (EmissionObject.isCompanyLevel) {
    config.params["company"] =
      localStorage.getItem("company") &&
      JSON.parse(localStorage.getItem("company") || "").id;
  } else {
    config.params["business_unit"] =
      localStorage.getItem("currentBusinessUnit") &&
      JSON.parse(localStorage.getItem("currentBusinessUnit") || "").id;
  }
  config.params.page = (EmissionObject.controller?.page || 0) + 1;
  config.params.limit = EmissionObject.controller?.limit;
  return axiosAuth.get(API_PATH().apis.importfiles, config);
};

export const discardEmissions = (
  EmissionRequestObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.put(API_PATH().apis.discardemissions, EmissionRequestObject);
};

export const removeFileService = (
  EmissionObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.put(API_PATH().apis.removefile, EmissionObject);
};

export const generateReportService = (
  requestObject: any
): Promise<AxiosResponse> => {
  requestObject.protocol =
    localStorage.getItem("protocol") == "ghg" ? "ghg" : "iso";
  return axiosAuth.post(API_PATH().apis.report, requestObject, {
    responseType: "arraybuffer",
  });
};

export const generateGRIYearwiseReport = (
  requestObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.griYearwiseData, requestObject, {
    responseType: "arraybuffer",
  });
};

export const generateSummaryReportService = (
  requestObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.summaryreport, requestObject, {
    responseType: "arraybuffer",
  });
};

export const setErrorsByFile = (fileDetails: any) => {
  // const file = allFiles.find((each: any) => each.id === fileID);
  const file = fileDetails;
  let errorsArray: any = [];
  for (const key in file.errors) {
    if (file.errors[key].substring(0, 3) === "BLK") {
      const errorCode = file.errors[key].split(" - ")[0];
      const errorObject = {
        number: key,
        error_code: errorCode,
        ...bulkUploadErrors[errorCode as keyof typeof bulkUploadErrors],
      };
      errorsArray = [...errorsArray, errorObject];
    } else {
      const errorObject = {
        number: key,
        error_code: "-",
        error_text: file.errors[key],
        error_description: "-",
        help_link: "Link",
      };
      errorsArray = [...errorsArray, errorObject];
    }
  }
  return errorsArray;
};

export const targetUOMService = (): Promise<AxiosResponse> => {
  // let config: AxiosRequestConfig = {
  //   params: EmissionRequestObject,
  // };
  return axiosAuth.get(API_PATH().apis.targetuoms);
};

export const emissionsByYearService = (
  businessUnit: string,
  scope: string,
  category: string
): Promise<AxiosResponse> => {
  scope = scope === "Scope 1" ? "1" : scope;
  category = category === "Category 1.1" ? "10" : category;
  let config: AxiosRequestConfig = {
    params: { businessUnit: businessUnit, scope: scope, category: category },
  };
  return axiosAuth.get(API_PATH().apis.emissionsbyyear, config);
};

export const targetsByYearService = (
  businessUnit: string,
  type: string,
  scope: string,
  category: string
): Promise<AxiosResponse> => {
  scope = scope === "Scope 1" ? "1" : scope;
  category = category === "Category 1.1" ? "10" : category;
  let config: AxiosRequestConfig = {
    params: { businessUnit, type, scope, category },
  };
  return axiosAuth.get(API_PATH().apis.targetsbyyear, config);
};

export const metricsByYearService = (
  businessUnit: string,
  metric: string,
  currentTabName: string,
  scope: string,
  category: string
): Promise<AxiosResponse> => {
  scope = scope === "Scope 1" ? "1" : scope;
  category = category === "Category 1.1" ? "10" : category;
  let config: AxiosRequestConfig = {
    params: {
      businessUnit: businessUnit,
      metric: metric,
      scope: scope,
      category: category,
      type: currentTabName,
    },
  };
  return axiosAuth.get(API_PATH().apis.metricsbyyear, config);
};

export const metricsService = (
  businessUnit: string
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      businessUnit: businessUnit,
    },
  };
  return axiosAuth.get(API_PATH().apis.custommetrics, config);
};

export const getEmissionsData = (
  businessUnit: string,
  targetCategories: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      businessUnit: businessUnit,
      years: targetCategories,
    },
  };
  return axiosAuth.get(API_PATH().apis.emissionsData, config);
};

export const getEmissionSourcesData = (
  emission_type: number,
  emission_sub_type: number,
  method: number,
  type: string
): Promise<AxiosResponse> => {
  // let company =
  //   localStorage.getItem("company") &&
  //   JSON.parse(localStorage.getItem("company") || "").id;
  let config: AxiosRequestConfig = {
    params: {
      emission_type,
      emission_sub_type,
      method,
      type,
    },
  };
  return axiosAuth.get(API_PATH().apis.emissionsources, config);
};

export const getAllCategories = (): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      protocol: "ISO",
      categoryLevel:
        localStorage.getItem("protocol") == "ghg"
          ? "SubCategory1"
          : "SubCategory2",
    },
  };
  return axiosAuth.get(API_PATH().apis.allcategories, config);
};
export const createCustomEmissionFactor = (
  EmissionObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.emissionfactor, EmissionObject);
};

export const getCustomEmissionList = (
  businessUnitObject?: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      isCompany: true,
    },
  };
  if (businessUnitObject?.controller) {
    config.params.page = (businessUnitObject?.controller?.page || 0) + 1;
    config.params.limit = businessUnitObject?.controller?.limit;
  } else if (businessUnitObject?.emissionTarget) {
    config.params.emissionTarget = true;
    businessUnitObject?.hasTarget && (config.params.hasTarget = true);
  }
  return axiosAuth.get(API_PATH().apis.customemissionfactors, config);
};

export const getSourceEmissionList = (
  businessUnitObject?: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {},
  };
  if (businessUnitObject?.controller) {
    config.params.page = (businessUnitObject?.controller?.page || 0) + 1;
    config.params.limit = businessUnitObject?.controller?.limit;
  } else if (businessUnitObject?.emissionTarget) {
    config.params.emissionTarget = true;
    businessUnitObject?.hasTarget && (config.params.hasTarget = true);
  }
  console.log("config", config);
  return axiosAuth.get(API_PATH().apis.customemissionfactors, config);
};

export const getCustomEmissionService = (EmissionRequestObject: {
  method: string;
  type: string;
  sub_type: string;
  category: string;
}): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: EmissionRequestObject,
  };
  return axiosAuth.get(API_PATH().apis.customemissionfactor, config);
};

export const updateEmissionVerifierStatus = (
  EmissionStatusObject: any
): Promise<AxiosResponse> => {
  //const company = JSON.parse(localStorage.getItem("company") || "").id;
  const businessUnit =
    localStorage.getItem("currentBusinessUnit") &&
    JSON.parse(localStorage.getItem("currentBusinessUnit") || "{}").id;
  EmissionStatusObject.businessUnit = businessUnit;
  //EmissionStatusObject.company = company;

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  EmissionStatusObject.auditor = user.id;
  EmissionStatusObject.auditRequest =
    localStorage.getItem("auditRequestId") &&
    JSON.parse(localStorage.getItem("auditRequestId") || "");
  EmissionStatusObject.lastUpdatedBy = user.id;
  EmissionStatusObject.lastUpdatedByName = user.email;

  return axiosAuth.put(
    API_PATH().apis.externalVerifierStatus,
    EmissionStatusObject
  );
};

export const getVerifierEmissionSummary = (): Promise<AxiosResponse> => {
  let user = JSON.parse(localStorage.getItem("user") || "{}");
  let auditRequestId =
    localStorage.getItem("auditRequestId") &&
    JSON.parse(localStorage.getItem("auditRequestId") || "");
  let config: AxiosRequestConfig = {
    params: {
      auditor: user.id,
      auditRequest: auditRequestId,
    },
  };
  return axiosAuth.get(API_PATH().apis.externalVerifierEmissionSummary, config);
};

export const getPcmMappings = () => {
  return axiosAuth.get(API_PATH().apis.pcmMappings);
};
